// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__25VL7","insightsList":"newBusinessInsightsMenu_insightsList__26Z-w","active":"newBusinessInsightsMenu_active__2aC7C"};